import { render, staticRenderFns } from "./EmailTemplatesView.vue?vue&type=template&id=73929389"
import script from "./EmailTemplatesView.vue?vue&type=script&lang=js"
export * from "./EmailTemplatesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports